import React, { useEffect } from 'react';

import ListItemText from '@mui/material/ListItemText';
import { ListItemButton } from '@mui/material';


export default function SideSettings(props) {

    const { currentPage, open, setOpen, title, subtitle, data } = props

    // SIDELIST FUNCTIONS
    const toggleList = () => {
        setOpen(!open)
    }

    useEffect(() => {
    }, [currentPage])

    return (
        <React.Fragment>
            <ListItemButton
                onClick={toggleList}
                sx={{
                    px: 3,
                    pt: 1.8,
                    pb:  1.8,
                    borderRadius: 1,
                    transition: '0.1s',
                    '&:hover, &:focus': { '& svg': { opacity: open ? 1 : 0 } },}} >
                <ListItemText
                    primary={title}
                    primaryTypographyProps={{
                        fontSize: 15,
                        fontWeight: 'bold',
                        lineHeight: '20px',
                        mb: '2px',
                    }}
                    secondary={subtitle}
                    secondaryTypographyProps={{
                        noWrap: false,
                        fontSize: 12,
                        lineHeight: '16px',
                        color: 'rgba(255,255,255,0.5)',
                    }}
                    sx={{ my: 0 }}
                />
            </ListItemButton>
        </React.Fragment>
    );
}
